var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    { ref: "modal", on: { opened: _vm.onOpened, closed: _vm.onClosed } },
    [
      _c("div", { staticClass: "building-info-wrapper" }, [
        _c("div", { staticClass: "building-info-inner" }, [
          _c("article", { staticClass: "building-info" }, [
            _c("div", { staticClass: "building-info-image-wrapper" }, [
              _c("img", {
                staticClass: "building-info-image",
                attrs: {
                  src: _vm.currentBuilding.thumbnail,
                  alt: _vm.currentBuilding.name,
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentBuilding.advertiseLink,
                    expression: "currentBuilding.advertiseLink",
                  },
                ],
                staticClass: "building-info-icon-wrapper",
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "building-info-icon-a",
                    attrs: { href: _vm.setAdvertiseLinkHref, target: "_blank" },
                  },
                  [
                    _c("i", {
                      staticClass: "building-info-icon isif isif-foreign",
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("hr", { staticClass: "building-info-hr" }),
            _vm._v(" "),
            _c("pre", { staticClass: "building-info-desc pre-custom" }, [
              _vm._v(
                _vm._s(
                  _vm.currentBuilding.descriptionMulti[_vm.lang] ||
                    _vm.currentBuilding.description
                )
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }